import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const data = [
  { name: "Sat", visitors: 120 },
  { name: "Sun", visitors: 200 },
  { name: "Mon", visitors: 150 },
  { name: "Tue", visitors: 300 },
  { name: "Wed", visitors: 250 },
  { name: "Thu", visitors: 400 },
  { name: "Fri", visitors: 350 },
];

export default function VisitorOverview() {
  return (
    <div style={{ width: "100%", height: 600 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="visitors"
            stroke="#4f46e5"
            strokeWidth={3}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
